<script lang="ts">
  import ButtonInputGroup from "./ButtonInputGroup.svelte";
  import PickerCard from "./PickerCard.svelte";

  export let selectVintage: (vintage: string) => void;
  export let selectedVintage: string | number;
  export let vintages: string[] = [];
  export let displayHeader = true;

  $: {
    if (vintages.length && !(selectedVintage && vintages.includes(String(selectedVintage)))) {
      selectVintage(vintages[0]);
    }
  }
</script>

{#if !displayHeader}
  <ButtonInputGroup
    values={vintages}
    selectValue={selectVintage}
    selectedValue={selectedVintage}
    dataTestId={"vintage-picker"}
  />
{:else}
  <PickerCard
    header="Vintage"
    values={vintages}
    selectValue={selectVintage}
    selectedValue={selectedVintage}
    dataTestId={"vintage-picker"}
  />
{/if}
